import GeoJSON from 'ol/format/GeoJSON';
import {
  GEOSERVER_URL,
  GEOSERVER_USERNAME,
  GEOSERVER_PASSWORD,
} from '../constants/geoserver';

const geojsonFormat = new GeoJSON();

// Polygon.getInteriorPoint tek nokta döner. MultiPolygon'da bu metot yoktur;
// iç noktalar getInteriorPoints ile gelir.
const interiorCoordinates = (geometry) => {
  if (typeof geometry.getInteriorPoint === 'function') {
    return [geometry.getInteriorPoint().getCoordinates()];
  }
  if (typeof geometry.getInteriorPoints === 'function') {
    return geometry.getInteriorPoints().getCoordinates();
  }
  const first = geometry.getFirstCoordinate?.();
  return first ? [first] : [];
};

// Uygulama veritabanında eylulyesil olmayabilir. Katman GeoServer'da duruyor.
const fetchEylulYesilForParcel = async (parcelFeature) => {
  const parcelGeometry = geojsonFormat.readGeometry(parcelFeature.geometry);
  const [minx, miny, maxx, maxy] = parcelGeometry.getExtent();
  const params = new URLSearchParams({
    service: 'WFS',
    version: '1.1.0',
    request: 'GetFeature',
    typename: 'tarim:eylul_yesil_2026',
    outputFormat: 'application/json',
    srsName: 'EPSG:32637',
    bbox: `${minx},${miny},${maxx},${maxy},EPSG:32637`,
  });

  const response = await fetch(`${GEOSERVER_URL}/wfs?${params}`, {
    headers: {
      Authorization: `Basic ${btoa(`${GEOSERVER_USERNAME}:${GEOSERVER_PASSWORD}`)}`,
    },
  });

  if (!response.ok) {
    throw new Error('Eylül Yeşil katmanı okunamadı');
  }

  const collection = await response.json();
  const features = [];
  const list = [];

  (collection.features || []).forEach((feature) => {
    const geometry = geojsonFormat.readGeometry(feature.geometry);
    const anchors = interiorCoordinates(geometry);
    const insideParcel = anchors.some((anchor) =>
      parcelGeometry.intersectsCoordinate(anchor)
    );
    if (!insideParcel) {
      return;
    }

    const alan = geometry.getArea();
    const id = feature.properties?.id ?? feature.id;
    list.push({ id, alan });
    features.push({
      type: 'Feature',
      geometry: feature.geometry,
      properties: {
        id,
        alan,
        etiket: 'Eylül Yeşil',
      },
    });
  });

  return {
    list,
    collection: {
      type: 'FeatureCollection',
      features,
    },
  };
};

export default fetchEylulYesilForParcel;
